import React, { useEffect, useRef } from 'react';
import TablePagination from '@mui/material/TablePagination';
import usePagination from 'hooks/usePagination';

export default function CustomTablePagination({
  storageKey,
  count,
  onFetch,
  defaults,
  rowsPerPageOptions = [50, 100],
  ...rest
}) {
  const { page, limit, offset, setPage, setLimit } = usePagination(storageKey, defaults);
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }

    onFetch({ _offset: offset, _limit: limit });
    //eslint-disable-next-line
  }, [offset, limit]);

  return (
    <TablePagination
      component="div"
      count={count}
      rowsPerPage={limit}
      page={page}
      onPageChange={(_e, newPage) => setPage(newPage)}
      onRowsPerPageChange={(e) => setLimit(+e.target.value)}
      rowsPerPageOptions={rowsPerPageOptions}
      {...rest}
    />
  );
}
